import { createFileRoute, redirect } from '@tanstack/react-router';

import { paths } from 'src/routes/paths';

// Legacy route -- OAuth callbacks now redirect to /brand/$clientId/integrations/mailchimp
export const Route = createFileRoute('/_authed/dashboard/o/$orgId/settings/integrations/mailchimp')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: paths.dashboard.orgSettings(params.orgId).client.brand,
    });
  },
});
